import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { BookingCodePrefixDto } from '@/features/dashboard/bookingCodePrefix/types/BookingCodePrefixDto.ts';

const bookingCodePrefixApi = {
  get: async (): Promise<BookingCodePrefixDto> => {
    return await fetchPrivateApi<BookingCodePrefixDto>(
      'GET',
      'settings/booking/code-prefix',
    );
  },
  set: async (dto: BookingCodePrefixDto): Promise<BookingCodePrefixDto> => {
    return await fetchPrivateApi<BookingCodePrefixDto>(
      'PUT',
      'settings/booking/code-prefix',
      dto,
    );
  },
};

export default bookingCodePrefixApi;
